<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DRadioEditor'
export default {
  name: 'DSexEditor',
  extends: compoment
}
</script>
